import { ReactComponent } from './invoice-xl.svg';
export const InvoiceIconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=invoice-xl.js.map